<template>
  <table
    :style="cssVars"
    :class="style.borders ? 'bordered' : ''"
    class="styled-table selectable"
  >
    <thead>
      <tr>
        <th></th>
        <th v-if="row2Values.length"></th>
        <th
          v-for="(cell, cellIndex) in validColumn1Values"
          :key="cell.id + 'thead.' + cellIndex"
          :colspan="getValidColumns2(cell.value).length"
        >
          {{ cell.text }}
        </th>
        <th>Total</th>
      </tr>

      <tr v-if="column2Values.length">
        <th></th>
        <th v-if="row2Values.length"></th>
        <div
          style="display: contents"
          v-for="(cell1, cellIndex1) in validColumn1Values"
          :key="cell1.id + 'cellIndex1.' + cellIndex1"
        >
          <th
            v-for="(cell2, cellIndex2) in getValidColumns2(cell1.value)"
            :key="cell2.id + '.' + cellIndex2"
          >
            {{ cell2.text }}
          </th>
        </div>
        <th></th>
      </tr>
    </thead>
    <template
      style="display: contents"
      v-for="(tableRow1, row1Index) in validRow1Values"
    >
      <td
        class="accent-color"
        :key="tableRow1.id + 'row1Index.' + row1Index"
        v-if="getValidRows2(tableRow1.value).length"
        :rowspan="
          getValidRows2(tableRow1.value).length
            ? getValidRows2(tableRow1.value).length + 1
            : 1
        "
      >
        {{ tableRow1.text }}
      </td>

      <tr
        v-for="(tableRow2, row2Index) in getValidRows2(tableRow1.value).length
          ? getValidRows2(tableRow1.value)
          : [null]"
        :key="
          tableRow2 ? tableRow2.id : '' + 'row2Index.' + row1Index + row2Index
        "
      >
        <td
          v-if="!getValidRows2(tableRow1.value).length"
          :rowspan="
            getValidRows2(tableRow1.value).length
              ? getValidRows2(tableRow1.value).length
              : 1
          "
        >
          {{ tableRow1.text }}
        </td>

        <td v-if="tableRow2">
          {{ tableRow2.text }}
        </td>

        <div
          style="display: contents"
          v-for="(cell, cellIndex) in validColumn1Values"
          :key="cell.id + 'cellIndex.' + cellIndex"
        >
          <td
            v-if="
              !getValidColumns2(cell.value).length &&
              cell.value !== tableRow1.value
            "
          >
            {{
              getCount(
                logs,
                { row1, row2, column1, column2 },
                {
                  column1Value: cell.value,
                  row1Value: tableRow1.value,
                  row2Value: tableRow2 ? tableRow2.value : null
                }
              )
            }}
          </td>
          <td
            v-if="
              !getValidColumns2(cell.value).length &&
              cell.value === tableRow1.value
            "
          ></td>
          <td
            v-for="(cell2, cellIndex2) in getValidColumns2(cell.value)"
            :key="cell2.id + 'cellIndex2.' + cellIndex2"
          >
            {{
              getCount(
                logs,
                { row1, row2, column1, column2 },
                {
                  column1Value: cell.value,
                  row1Value: tableRow1.value,
                  column2Value: cell2.value,
                  row2Value: tableRow2 ? tableRow2.value : null
                }
              )
            }}
          </td>
        </div>
        <td>
          {{
            getRowTotal(
              logs,
              { row1, row2 },
              {
                row1Value: tableRow1.value,
                row2Value: tableRow2 ? tableRow2.value : null
              }
            )
          }}
        </td>
      </tr>
    </template>

    <tr>
      <td>Total</td>
      <td v-if="row2Values.length"></td>
      <div
        v-for="(cell, cellIndex) in validColumn1Values"
        :key="cell.id + 'cellIndex.' + cellIndex"
        style="display: contents"
      >
        <td v-if="!getValidColumns2(cell.value).length">
          {{ getColumnTotal(logs, { column1 }, { column1Value: cell.value }) }}
        </td>

        <div
          v-if="getValidColumns2(cell.value).length"
          style="display: contents"
        >
          <td
            v-for="(cell2, cellIndex2) in getValidColumns2(cell.value)"
            :key="cell2.id + 'cellIndex2.' + cellIndex2"
          >
            {{
              getColumnTotal(
                logs,
                { column1, column2 },
                { column1Value: cell.value, column2Value: cell2.value }
              )
            }}
          </td>
        </div>
      </div>
      <td>{{ total }}</td>
    </tr>
  </table>
</template>

<script>
import helpers from '../mixins/statsHelperFunc'
export default {
  mixins: [helpers],
  props: {
    logs: {
      type: Array,
      required: true
    },
    statsData: { type: Object },
    selectedUsers: Array,
    coordinatedUsers: Array
  },
  data() {
    return {
      allComponents: this.allStatsComponents(this.statsData.logbookType),
      style: {
        borders: true,
        borderColor: '#cccccc',
        colors: ['#ffffff']
      }
    }
  },
  mounted() {
    this.$root.$emit('isTable', true)
    this.$root.$on('selectedStyle', style => {
      this.style = style
    })
  },
  methods: {
    applyICD10(dimention1, dimention2) {
      return (
        dimention1 &&
        dimention2 &&
        ((dimention1.id === 'icd10-chapters' &&
          dimention2.id === 'icd10-sections') ||
          (dimention1.id === 'icd10-sections' && dimention2.type === 'icd10') ||
          (dimention1.id === 'icd10-chapters' && dimention2.type === 'icd10'))
      )
    },
    filterChildrenICD10(parentValue, children) {
      if (
        this.applyICD10(this.row1, this.row2) ||
        this.applyICD10(this.column1, this.column2)
      ) {
        const minValue = parentValue.split('-')[0]
        const maxValue = parentValue.split('-')[1]

        return children.filter(c => {
          let icdoCode

          if (!c.maxSectionCode && !c.maxChapterCode) {
            icdoCode = c.value.split(':')[0]
          }

          return (
            (c.maxSectionCode &&
              c.minSectionCode &&
              c.maxSectionCode >= minValue &&
              c.maxSectionCode <= maxValue &&
              c.minSectionCode >= minValue &&
              c.minSectionCode <= maxValue) ||
            (c.maxChapterCode &&
              c.minChapterCode &&
              c.maxChapterCode >= minValue &&
              c.maxChapterCode <= maxValue &&
              c.minChapterCode >= minValue &&
              c.minChapterCode <= maxValue) ||
            (icdoCode >= minValue && icdoCode <= maxValue)
          )
        })
      }

      return children
    },
    getValidRows2(row1Value) {
      let row2ValuesCpy = JSON.parse(JSON.stringify(this.row2Values))

      row2ValuesCpy = this.filterChildrenICD10(row1Value, row2ValuesCpy)

      return row2ValuesCpy.filter(r =>
        this.getRowTotal(
          this.logs,
          { row1: this.row1, row2: this.row2 },
          { row1Value: row1Value, row2Value: r.value }
        )
      )
    },
    getValidColumns2(column1Value) {
      let column2ValuesCpy = JSON.parse(JSON.stringify(this.column2Values))

      column2ValuesCpy = this.filterChildrenICD10(
        column1Value,
        column2ValuesCpy
      )

      return column2ValuesCpy.filter(r =>
        this.getColumnTotal(
          this.logs,
          { column1: this.column1, column2: this.column2 },
          { column1Value: column1Value, column2Value: r.value }
        )
      )
    },
    getRowTotal(logs, { row1, row2 }, { row1Value, row2Value }) {
      return logs.filter(
        l =>
          l[row1.id] &&
          this.isEqualOrContains(row1Value, l[row1.id], row1) &&
          (!row2Value ||
            (l[row2.id] && this.isEqualOrContains(row2Value, l[row2.id], row2)))
      ).length
    },
    getColumnTotal(logs, { column1, column2 }, { column1Value, column2Value }) {
      return logs.filter(
        l =>
          l[column1.id] &&
          this.isEqualOrContains(column1Value, l[column1.id], column1) &&
          (!column2Value ||
            (l[column2.id] &&
              this.isEqualOrContains(column2Value, l[column2.id], column2)))
      ).length
    }
  },
  computed: {
    row1() {
      return this.statsData.variables.row1
    },
    row2() {
      return this.statsData.variables.row2
    },
    column1() {
      return this.statsData.variables.column1
    },
    column2() {
      return this.statsData.variables.column2
    },
    column1Values() {
      // getColumnOptions(dimention, components, filteredLogs, selectedUsers)
      return this.getColumnOptions(this.column1, this.allComponents, this.logs)
    },
    row1Values() {
      if (this.row1 && this.row1.id === 'userId') {
        let users = this.selectedUsers.length
          ? this.selectedUsers
          : this.coordinatedUsers
        return users
      } else {
        return this.getColumnOptions(this.row1, this.allComponents, this.logs)
      }
    },
    column2Values() {
      return this.getColumnOptions(this.column2, this.allComponents, this.logs)
    },
    row2Values() {
      return this.getColumnOptions(this.row2, this.allComponents, this.logs)
    },
    validRow1Values() {
      if (this.row2Values.length) {
        return this.row1Values.filter(r => this.getValidRows2(r.value).length)
      } else {
        return this.row1Values
      }
    },
    validColumn1Values() {
      if (this.column2Values.length) {
        return this.column1Values.filter(
          r => this.getValidColumns2(r.value).length
        )
      } else {
        return this.column1Values
      }
    },
    total() {
      if (this.column1Values && this.column1Values.length) {
        if (this.column2Values && this.column2Values.length) {
          return this.column1Values.reduce(
            (c1Acc, c1) =>
              c1Acc +
              this.column2Values.reduce(
                (c2Acc, c2) =>
                  c2Acc +
                  this.getColumnTotal(
                    this.logs,
                    {
                      column1: this.column1,
                      column2: this.column2
                    },
                    {
                      column1Value: c1.value,
                      column2Value: c2.value
                    }
                  ),
                0
              ),
            0
          )
        } else {
          return this.column1Values.reduce(
            (acc, c) =>
              acc +
              this.getColumnTotal(
                this.logs,
                {
                  column1: this.column1
                },
                {
                  column1Value: c.value
                }
              ),
            0
          )
        }
      } else if (this.row1Values && this.row1Values.length) {
        if (this.row2Values && this.row2Values.length) {
          return this.row1Values.reduce(
            (c1Acc, c1) =>
              c1Acc +
              this.getValidRows2(c1.value).reduce(
                (c2Acc, c2) =>
                  c2Acc +
                  this.getRowTotal(
                    this.logs,
                    { row1: this.row1, row2: this.row2 },
                    { row1Value: c1.value, row2Value: c2.value }
                  ),
                0
              ),
            0
          )
        } else {
          return this.row1Values.reduce(
            (acc, c) =>
              acc +
              this.getRowTotal(
                this.logs,
                { row1: this.row1 },
                { row1Value: c.value }
              ),
            0
          )
        }
      } else {
        return 0
      }
    },
    cssVars() {
      return {
        '--bg-color': this.style.colors[0],
        '--bg-light-color': this.style.colors[0] + 20,
        '--accent-color': this.style.colors[0] + 60,
        '--border-collapse': this.style.borders ? 'collapse' : 'inherit',
        '--border-color': this.style.borderColor
      }
    }
  }
}
</script>

<style scoped>
.styled-table {
  font-size: 0.9em;
  font-family: sans-serif;
  width: 100%;
  border-collapse: var(--border-collapse);
}
.styled-table.bordered td,
.styled-table.bordered thead {
  border-bottom: 1px solid var(--border-color);
}
.styled-table thead tr {
  background-color: var(--bg-color) !important;
  text-align: left;
}
.styled-table th,
.styled-table td {
  padding: 12px 15px;
  text-align: center;
  vertical-align: middle;
}

.styled-table td.accent-color {
  background-color: var(--accent-color);
}

.styled-table tr:nth-of-type(even) {
  background-color: var(--bg-light-color);
}

.styled-table tr:last-of-type {
  border-bottom: 2px solid #009879;
}
</style>
